import { render, staticRenderFns } from "./ManagementModal.vue?vue&type=template&id=c89a3d0e&scoped=true"
import script from "./ManagementModal.vue?vue&type=script&lang=js"
export * from "./ManagementModal.vue?vue&type=script&lang=js"
import style0 from "./ManagementModal.vue?vue&type=style&index=0&id=c89a3d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89a3d0e",
  null
  
)

export default component.exports